const initSliders = () => {
  const initFlavorSwipers = () => {
    document
      .querySelectorAll(
        ".product-card__flavor:not(.upsell-products .product-card__flavor):not(.swiper-initialized)"
      )
      .forEach((el) => {
        new Swiper(el, {
          slidesPerView: 4,
          nested: true,
          noSwipingClass: "swiper-no-swiping",
          on: {
            touchStart: function (swiper, event) {
              event.stopPropagation();
            },
            touchMove: function (swiper, event) {
              event.stopPropagation();
            },
            touchEnd: function (swiper, event) {
              event.stopPropagation();
            },
          },
        });
      });

    document
      .querySelectorAll(
        ".upsell-products .product-card__flavor:not(.swiper-initialized)"
      )
      .forEach((el) => {
        new Swiper(el, {
          slidesPerView: 2,
          spaceBetween: 5,
          nested: true,
          noSwipingClass: "swiper-no-swiping",
          on: {
            touchStart: function (swiper, event) {
              event.stopPropagation();
            },
            touchMove: function (swiper, event) {
              event.stopPropagation();
            },
            touchEnd: function (swiper, event) {
              event.stopPropagation();
            },
          },
        });
      });
  };

  const recommendationsSection = document.querySelector(
    ".product-recommendations"
  );
  if (recommendationsSection) {
    new MutationObserver(() => {
      new Swiper(".product-recommendations__slider", {
        slidesPerView: "auto",
        spaceBetween: 30,
        breakpoints: {
          992: { slidesPerView: 3 },
        },
        on: { init: initFlavorSwipers },
      });
    }).observe(recommendationsSection, { childList: true });
  }

  initFlavorSwipers();

  // ----- Function to show description by ID -----
  function showDescriptionById(id) {
    const descriptions = document.querySelectorAll(".text-logo__description");
    const logos = carouselContainer.querySelectorAll(".swiper-slide");

    descriptions.forEach((desc) => {
      desc.classList.toggle("active", desc.dataset.blockId === id);
    });

    logos.forEach((logo) => {
      logo.classList.toggle("active", logo.dataset.blockId === id);
    });
  }

  // ----- Function to activate slide toggle -----
  function activateSlideToggle(container) {
    const slides = container.querySelectorAll(".swiper-slide");

    slides.forEach((slide) => {
      const toggles = slide.querySelectorAll(".review-toggle");

      toggles.forEach((toggle) => {
        const img = toggle.querySelector("img");

        if (img) {
          img.addEventListener("click", () => {
            toggles.forEach((el) => el.setAttribute("data-active", "false"));
            toggle.setAttribute("data-active", "true");
          });
        }
      });
    });
  }

  // ----- Individual sliders -----
  new Swiper(".topbar__slider", {
    slidesPerView: 1,
    effect: "fade",
    loop: true,
    autoplay: { delay: 3000 },
    navigation: {
      nextEl: ".topbar__slider-next",
      prevEl: ".topbar__slider-prev",
    },
  });

  new Swiper(".products-slider-tabs__slider", {
    slidesPerView: "auto",
    spaceBetween: 30,
    breakpoints: {
      992: { slidesPerView: 3 },
    },
  });

  new Swiper(".products-slider-tabs__tabs-buttons", {
    slidesPerView: "auto",
    spaceBetween: 20,
    slideToClickedSlide: true,
  });

  new Swiper(".image-content-tabs__buttons", {
    slidesPerView: "auto",
    spaceBetween: 10,
    slideToClickedSlide: true,
  });

  new Swiper(".posts-slider__slider", {
    slidesPerView: "auto",
    loop: true,
    spaceBetween: 30,
    breakpoints: {
      992: { slidesPerView: 3 },
    },
  });

  new Swiper(".blog-slider__slider", {
    slidesPerView: "auto",
    loop: true,
    centeredSlides: true,
    spaceBetween: 20,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    pagination: {
      el: ".swiper-pagination",
    },
    breakpoints: {
      992: {
        spaceBetween: 50,
      },
    },
  });

  // ----- Logo carousel with description -----
  const carouselContainer = document.querySelector(".text-logo__carousel");
  if (carouselContainer) {
    const textLogoSwiper = new Swiper(carouselContainer, {
      spaceBetween: 39,
      slidesPerView: "auto",
      grabCursor: true,
      loop: true,
      centeredSlides: true,
      breakpoints: {
        576: {
          spaceBetween: 65,
          slidesPerView: 5,
          centeredSlides: false,
        },
      },
      on: {
        init() {
          const activeSlide = this.slides[this.activeIndex];
          const firstId = activeSlide?.dataset.blockId;
          if (firstId) showDescriptionById(firstId);
        },
        slideChange() {
          const activeSlide = this.slides[this.activeIndex];
          const blockId = activeSlide.dataset.blockId;
          if (blockId) showDescriptionById(blockId);
        },
      },
    });
  }

  // ----- Review sliders desktop -----
  document.querySelectorAll(".review-container__imgs").forEach((swiperEl) => {
    new Swiper(swiperEl, {
      slidesPerView: 1,
      spaceBetween: 20,
      slideToClickedSlide: true,
      navigation: {
        nextEl: swiperEl.querySelector(".swiper-button-next"),
        prevEl: swiperEl.querySelector(".swiper-button-prev"),
      },
      on: {
        init() {
          activateSlideToggle(swiperEl);
        },
      },
    });
  });

  // ----- Review sliders mobile -----
  document.querySelectorAll(".review-mobile-swiper").forEach((slider) => {
    const swiper = new Swiper(slider, {
      slidesPerView: "auto",
      centeredSlides: true,
      spaceBetween: 20,
      slideToClickedSlide: true,
      initialSlide: 1,
    });

    slider.swiperInstance = swiper;
  });

  // ----- Testimonial tabs -----
  const tabButtons = document.querySelectorAll(".tabs-js-button");
  const tabContents = document.querySelectorAll(".tabs-js-content");

  tabButtons.forEach((button) => {
    button.addEventListener("click", () => {
      const id = button.dataset.id;

      tabButtons.forEach((btn) => btn.classList.remove("active"));
      button.classList.add("active");

      tabContents.forEach((content) => {
        const contentId = content.getAttribute("id");
        const shouldShow = contentId === id || contentId === `mobile-${id}`;
        content.setAttribute("data-show", shouldShow ? "true" : "false");

        if (shouldShow) {
          const swiperEl = content.querySelector(".review-mobile-swiper");
          if (swiperEl?.swiperInstance) {
            swiperEl.swiperInstance.update();
            const middleIndex = Math.floor(
              swiperEl.swiperInstance.slides.length / 2
            );
            swiperEl.swiperInstance.slideTo(middleIndex, 300);
          }
        }
      });
    });
  });

  // ----- Product gallery (PDP) -----
  const productGalleryThumbs = new Swiper(".product-gallery-thumbs", {
    slidesPerView: 5,
    direction: "vertical",
    watchOverflow: true,
    watchSlidesVisibility: true,
    watchSlidesProgress: true,
    spaceBetween: 8,
  });

  new Swiper(".product-gallery-main", {
    slidesPerView: 1,
    loop: true,
    pagination: {
      el: ".product-gallery-main-pagination",
      clickable: true,
    },
    thumbs: {
      swiper: productGalleryThumbs,
    },
  });

  new Swiper(".single-recipe__slider--body", {
    slidesPerView: "auto",
    spaceBetween: 30,
    loop: true,
    breakpoints: {
      992: {
        slidesPerView: 3,
        spaceBetween: 50,
      },
    },
  });

  new Swiper(".posts-slider__body", {
    slidesPerView: "auto",
    spaceBetween: 20,
    loop: true,
    breakpoints: {
      992: {
        slidesPerView: 3,
        spaceBetween: 50,
      }
    },
  });

  new Swiper(".upsell-products__slider", {
    slidesPerView: "auto",
    spaceBetween: 10,
    slideToClickedSlide: true,
    breakpoints: {
      576: {
        slidesPerView: 3,
      },
      992: {
        spaceBetween: 30,
        slidesPerView: 3,
      },
    },
  });

  const swiperContainer = document.querySelector(".slider-logos__logos-swiper");

  if (swiperContainer) {
    const slides = swiperContainer.querySelectorAll(".swiper-slide");

    if (slides.length <= 3) {
      swiperContainer.classList.add("center-mode");
    }

    new Swiper(swiperContainer, {
      slidesPerView: 2,
      spaceBetween: 50,
      loop: slides.length > 2,
      breakpoints: {
        576: {
          spaceBetween: 56,
          slidesPerView: 3,
        },
        992: {
          slidesPerView: 4,
          spaceBetween: 62.5,
        },
      },
    });
  }

  const LogosSlider = new Swiper(".quotes-logos__logos", {
    slidesPerView: 'auto',
    spaceBetween: 39,
    slideToClickedSlide: true,
    loop: true,
    breakpoints: {
      576: {
        slidesPerView: 3,
      },
      992: {
        slidesPerView: 5,
      },
    },
  });

  new Swiper(".quotes-logos__quotes", {
    slidesPerView: 1,
    allowTouchMove: false,
    loop: true,
    autoHeight: true,
    effect: 'fade',
    thumbs: {
      swiper: LogosSlider,
    },
  });


};

export { initSliders };
